module.exports = __webpack_public_path__ + "img/dash_quickicon_3.85ae5381.svg";